import { Pipe, PipeTransform } from '@angular/core';

import { LabelsEnum } from '@shared/sms/enums';

@Pipe({ name: 'notificationLabel' })
export class NotificationLabelPipe implements PipeTransform {
  private readonly reservationTypes = [LabelsEnum.resconf, LabelsEnum.rescheckin];

  transform(value: LabelsEnum): any {
    if (this.reservationTypes.includes(value)) {
      return 'confirmation';
    }

    if (value === LabelsEnum.toGoOrderReady) {
      return 'ready';
    }

    return value;
  }
}
